/* eslint-disable camelcase */
// import { isEmpty } from 'lodash';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';

import {
  CustomReportsService,
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto,
} from '../../services/wealthlane-report-services';
import { useNavigate } from 'react-router-dom';

const usePostCustomizeReportSaveAs = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const navigate = useNavigate();

  //   const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      const newPayload = { ...payload, reportConfigurationId: payload.id };

      return await handleRequest(
        CustomReportsService.postApiReportApiAppCustomReportsCustomReports(newPayload)
      );
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          closeModal();
          toast.success(<ToastComponent label='Success' message='Saved' />);
          navigate('/reports/custom-report-designer', {
            state: {
              id: response?.customReportId,
            },
            replace: true,
          });
          // navigate('/reports');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCustomizeReportSaveAs;
